import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { IMsMenu } from "../../interfaces/IMsMenu";

export const getListRolesNameSA = async () => {
  const dataAPI = await HttpService.get(
    ApiService.masterUser.getListRolesNameSA
  );

  return dataAPI.data.data;
};

export const getSearchListRolesNameSA = async (searchText?: string) => {
  const dataAPI = await HttpService.post(
    ApiService.masterRole.getSearchListRolesNameSA,
    JSON.stringify({
      SearchText: searchText,
    })
  );

  return dataAPI.data.data;
};

export const getSingleRoleMenuListSA = async (roleID?: string) => {
  const dataAPI = await HttpService.post(
    ApiService.masterRole.getSingleRoleMenuListSA,
    JSON.stringify({
      RoleID: roleID,
    })
  );

  return dataAPI.data.data;
};

export const editSingleRoleMenuListSA = async (
  listMenu?: IMsMenu[],
  roleName?: string,
  newRoleName?: string,
  roleID?: string,
  userUp?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.masterRole.editSingleRoleMenuListSA,
    JSON.stringify({
      ListMenu: listMenu,
      RoleName: roleName,
      NewRoleName: newRoleName,
      RoleID: roleID,
      UserUp: userUp,
    })
  );

  return dataAPI.data.data;
};

export const addSingleRoleMenuListSA = async (
  listMenu?: IMsMenu[],
  roleName?: string,
  userIn?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.masterRole.addSingleRoleMenuListSA,
    JSON.stringify({
      ListMenu: listMenu,
      RoleName: roleName,
      UserIn: userIn,
    })
  );

  return dataAPI.data.data;
};

export const deleteMultipleRoleSA = async (
  listRoleID?: string[],
  userUp?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.masterRole.deleteMultipleRoleSA,
    JSON.stringify({
      ListRoleID: listRoleID,
      UserUp: userUp,
    })
  );

  return dataAPI.data.data;
};
